<template>
    <ion-grid ref="content">
        <ion-row>
            <ion-col size="4">
                <ion-text class="text-body2-style">{{ transaction.displayDate }}</ion-text>
            </ion-col>
            <ion-col size="5">
                <div class="col-row-cont">
                    <ion-img :src="transactionImg" class="icon-desc-info" alt=""></ion-img>
                    <ion-text class="text-body2-style">{{ TransactionTypeLayOut[transaction.transaction_type] }}</ion-text>
                </div>
            </ion-col>
            <ion-col size="3" class="align-end">
                <ion-text class="text-body2-style ion-text-nowrap">{{ transaction.displayAmount }}</ion-text>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
import { TransactionTypeApi, TransactionTypeLayOut } from '../../util/constant'
export default {
    name: 'TransactionType',
    props: {
        transaction: Object,
    },
    data: function () {
        return {
            TransactionTypeApi,
            TransactionTypeLayOut,
            transactionImg: require('../../assets/imoney-bag-48.png'),
        }
    },
    methods: {},
}
</script>

<style scoped>
.col-row-cont {
    display: flex;
    flex-direction: row;
}
.icon-desc-info {
    min-width: 20px;
}
ion-img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}
.align-end {
    justify-content: flex-end;
    display: flex;
}
.align-center {
    justify-content: center;
    display: flex;
}
</style>
